export { LikeCommentFooter } from './LikeCommentFooter';
